import React from 'react'
import styles from "./styles/allCourseDesc.module.css"
const AllCourseDescription = () => {
    return (
        <div className={styles.allCourseDescriptionWrapper}>
            <p>Explore wide range of tutorials ranging from Web Development, Programming and Computer fundamentals. </p>
        </div>
    )
}

export default AllCourseDescription